import { Box, Stack } from "@mui/material";
import React from "react";
import { Color, FontStyle } from "../../constants";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const styles = {
  hoverButton: {
    cursor: "pointer",
    width: "24px",
    height: "24px",
    border: "2px solid #000",
    borderRadius: "4px",
    position: "relative",
  },
  icon: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: "18px",
  },
};

const px = 1;
const py = 1;
const SingleSchoolPanel = ({
  handleBeginEdit,
  handleDelete,
  schoolId,
  school_name,
  degree,
  major,
  start_month,
  start_year,
  end_month,
  end_year,
  grade,
  activities,
}) => {
  const [hovered, setHovered] = React.useState(false);
  const [deleteStep, setDeleteStep] = React.useState(0);
  return (
    <Stack
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setDeleteStep(0);
      }}
      direction="column"
      spacing={0}
      sx={{
        ...FontStyle.body,
        fontSize: "12px",
        width: "100%",
        border: `1px solid #000`,
        // px: 1,
        // py: 1,
        borderRadius: "4px",
        overflow: "hidden",
        position: "relative",
      }}>
      {hovered && (
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            position: "absolute",
            top: "4px",
            right: "6px",
            zIndex: "1",
            // backgroundColor: "#fff",
          }}>
          <Box
            sx={{ ...styles.hoverButton }}
            onClick={() => handleBeginEdit(schoolId)}>
            <EditOutlinedIcon
              sx={{
                ...styles.icon,
                backgroundColor: Color.lightGreen,
                "&:hover": {
                  backgroundColor: Color.mainGreen,
                },
              }}
            />
          </Box>
          <Box
            sx={{
              ...styles.hoverButton,
              backgroundColor: "#f003",
              ...(deleteStep !== 0 && {
                backgroundColor: "#f007",
                width: "fit-content",
                px: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }),
              "&:hover": {
                backgroundColor: deleteStep === 0 ? "#f007" : "#f00a",
              },
            }}
            onClick={() => {
              if (deleteStep === 0) {
                setDeleteStep(1);
              } else if (deleteStep === 1) {
                handleDelete(schoolId);
              }
            }}>
            {deleteStep === 0 ? (
              <DeleteOutlineOutlinedIcon sx={{ ...styles.icon }} />
            ) : (
              <Box
                sx={{
                  ...FontStyle.headingBody,
                }}>
                CONFIRM
              </Box>
            )}
          </Box>
        </Stack>
      )}
      <Box
        sx={{
          ...FontStyle.headingBody,
          fontSize: "14px",
          paddingBottom: "4px",
          // backgroundColor: "#0001",
          backgroundColor: Color.fettiLightBlue + "80",
          px,
          py,
        }}>
        {school_name}
      </Box>
      <Stack direction="column" spacing={0} sx={{ width: "100%", px, py }}>
        <Box>{degree}</Box>
        <Box>{major}</Box>
        {start_year && end_year ? (
          <Box
            sx={{
              color: Color.secondaryTextGray,
            }}>{`${start_month} ${start_year} - ${end_month} ${end_year}`}</Box>
        ) : start_year ? (
          <Box sx={{ color: Color.secondaryTextGray }}>{start_year}</Box>
        ) : end_year ? (
          <Box sx={{ color: Color.secondaryTextGray }}>{end_year}</Box>
        ) : null}
        {grade && <Box>Grade: {grade}</Box>}
        {activities ? <Box sx={{ paddingTop: "8px" }}>{activities}</Box> : null}
      </Stack>
    </Stack>
  );
};

export default SingleSchoolPanel;
